import * as type from "./type";

export const getUserLogListRequest = (data) => {
  return {
    type: type.GET_USER_LOG_LIST_REQUEST,
    payload: data,
  };
};
export const getUserLogListSuccess = (data) => {
  return {
    type: type.GET_USER_LOG_LIST_SUCCESS,
    payload: data,
  };
};
export const deleteUserLogRequest = (data) => {
  return {
    type: type.DELETE_USER_LOG_REQUEST,
    payload: data,
  };
};
export const deleteUserLogSuccess = (data) => {
  return {
    type: type.DELETE_USER_LOG_SUCCESS,
    payload: data,
  };
};
export const clearUserLogList = () => {
  return {
    type: type.CLEAR_USER_LOG_LIST,
  };
};
